import {gql} from "@apollo/client";
import {client} from "../../../../../graphql/client";
import {t} from "../../../../../i18n";
import i18n from "../../../../../i18n";

// 下载派送司机Excel模板
export const DOWNLOAD_DELIVERY_DRIVER_TEMPLATE = gql`
    query AccountDeliveryDriverQuery($language: String!) {
        downloadDeliveryDriverTemplate(language: $language)
    }
`;

// 定义查询结果的TypeScript接口
export interface DownloadDeliveryDriverTemplateResult {
    downloadDeliveryDriverTemplate: string; // Base64编码的Excel文件内容
}

// 下载模板文件的工具函数
export const downloadDeliveryDriverTemplate = async (): Promise<void> => {
    try {
        // 获取当前语言并规范化：后端期望 'zh', 'en', 'es' 格式，需要处理 'zh-CN' 等变体
        // 规范化语言代码，只取前两位（如 'zh-CN' -> 'zh'）
        const normalizeLanguage = (lang: string | undefined | null): string => {
            if (!lang) return 'en';
            return lang.toLowerCase().split('-')[0];
        };
        
        const currentLanguage = normalizeLanguage(
            i18n.resolvedLanguage || i18n.language || 'en'
        );
        const templateFileName = t('delivery.personnel.label.templateFileName');
        const {data} = await client.query<DownloadDeliveryDriverTemplateResult>({
            query: DOWNLOAD_DELIVERY_DRIVER_TEMPLATE,
            variables: {
                language: currentLanguage
            },
            fetchPolicy: 'no-cache' // 每次都从服务器获取最新模板
        });

        if (data?.downloadDeliveryDriverTemplate) {
            // 将Base64字符串转换为Blob
            const base64Data = data.downloadDeliveryDriverTemplate;
            const binaryData = atob(base64Data);
            const bytes = new Uint8Array(binaryData.length);

            for (let i = 0; i < binaryData.length; i++) {
                bytes[i] = binaryData.charCodeAt(i);
            }

            const blob = new Blob([bytes], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // 创建下载链接
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = templateFileName;

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 清理
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else {
            throw new Error('Failed to get template data');
        }
    } catch (error) {
        console.error('Failed to download template:', error);
        throw error;
    }
}; 